import React from "react";
import Logo from "./Logo.js";
import IcFacebook from "../../images/ic-facebook.svg";
import IcTwitter from "../../images/ic-twitter.svg";
import IcLinkedIn from "../../images/ic-linkedin.svg";
import IcInstagram from "../../images/ic-instagram.svg";
import IcDribble from "../../images/ic-dribble.svg";
import IcLocation from "../../images/ic-location.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#15558D] text-white mx-auto px-4">
      <div className="py-8 px-10 grid grid-flow-col auto-cols-fr gap-4">
        <div>
          <Logo color="text-white" />
          <p className="text-sm mt-5">
            Lorem ipsum dolor sit amet, consectetur em adipiscing elit, sed do
            eiusmod tempor.
          </p>
          <div className="flex gap-2 mt-3">
            <a
              href="#"
              className="border-2 border-white rounded-full inline-flex justify-center items-center h-8 w-8" title="Facebook"
            >
              <img src={IcFacebook} alt="facebook" className="w-2 h-auto" />
            </a>
            <a
              href="#"
              className="border-2 border-white rounded-full inline-flex justify-center items-center h-8 w-8" title="Twitter"
            >
              <img src={IcTwitter} alt="twitter" className="w-4 h-auto" />
            </a>
            <a
              href="#"
              className="border-2 border-white rounded-full inline-flex justify-center items-center h-8 w-8" title="LinkedIn"
            >
              <img src={IcLinkedIn} alt="linkedin" className="w-4 h-auto" />
            </a>
            <a
              href="#"
              className="border-2 border-white rounded-full inline-flex justify-center items-center h-8 w-8" title="Instagram"
            >
              <img src={IcInstagram} alt="instagram" className="w-4 h-auto" />
            </a>
            <a
              href="#"
              className="border-2 border-white rounded-full inline-flex justify-center items-center h-8 w-8" title="Dribble"
            >
              <img src={IcDribble} alt="dribble" className="w-4 h-auto" />
            </a>
          </div>
        </div>
        <div>
          <h5 className="font-semibold text-lg mb-3">For Patients</h5>
          <ul className="text-sm flex flex-col gap-3">
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Search for Doctors</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Login</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Register</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Booking</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Patient Dashboard</Link>
            </li>
          </ul>
        </div>
        <div>
          <h5 className="font-semibold text-lg mb-3">For Doctors</h5>
          <ul className="text-sm flex flex-col gap-3">
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Appointments</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Chat</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Login</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Register</Link>
            </li>
            <li className="list-disc list-inside hover:text-primary">
              <Link to={"/"}>Doctor Dashboard</Link>
            </li>
          </ul>
        </div>
        <div>
          <h5 className="font-semibold text-lg mb-3">Contact Us</h5>
          <ul className="text-sm text-white flex flex-col gap-3">
            <li className="flex items-start gap-3">
              <img src={IcLocation} className="w-4 h-4" alt="Location" />
              <p>3556 Beech Street, San Francisco,California, CA 94108</p>
            </li>
            <li className="flex items-start gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clipRule="evenodd"
                />
              </svg>

              <p>+1 315 369 5943</p>
            </li>
            <li className="flex items-start gap-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
              </svg>

              <p>doccure@example.com</p>
            </li>
          </ul>
        </div>
      </div>
      <div className="text-xs flex justify-between border-t py-5">
        <p>© 2022 Hallo Doctor. All rights reserved.</p>
        <div className="flex gap-5">
          <Link to={"#"} className="border-r pr-5 hover:text-primary">
            Terms and Conditions
          </Link>
          <Link to={"#"} className="hover:text-primary">Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
